import type { RaceRecording } from './race';

export interface LiveReviewWindow {
  identity: string;
  recording: RaceRecording;
  startMs: number;
}

/** A paused live review owns one immutable source window, never the growing stream. */
export function retainLiveReviewWindow(previous: LiveReviewWindow | null, recording: RaceRecording, startMs: number, enabled: boolean, resetKey: number): LiveReviewWindow | null {
  if (!enabled) return null;
  const identity = `${recording.session.key}:${recording.session.dateStart}:${resetKey}`;
  return previous?.identity === identity ? previous : {
    identity, recording, startMs: Math.max(0, Math.min(recording.durationMs, startMs)),
  };
}
